import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') === 'true');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedEmail = localStorage.getItem('email');
    if (storedToken && storedEmail) {
      setToken(storedToken);
      setUser({ email: storedEmail });
      // Re-validate admin status with the backend (source of truth)
      axios
        .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${storedToken}` } })
        .then((res) => {
          const admin = !!res.data.is_admin;
          setIsAdmin(admin);
          localStorage.setItem('isAdmin', admin ? 'true' : 'false');
        })
        .catch(() => {
          // Token invalid/expired - clear session
          localStorage.removeItem('token');
          localStorage.removeItem('email');
          localStorage.removeItem('isAdmin');
          setToken(null);
          setUser(null);
          setIsAdmin(false);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (newToken, email, admin = false) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('email', email);
    localStorage.setItem('isAdmin', admin ? 'true' : 'false');
    setToken(newToken);
    setUser({ email });
    setIsAdmin(!!admin);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('isAdmin');
    setToken(null);
    setUser(null);
    setIsAdmin(false);
  };

  const getAuthHeader = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{ user, token, isAdmin, login, logout, loading, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
};
